/**
 * Read Vite build-time vars (`import.meta.env.VITE_*`).
 * Legacy `REACT_APP_*` names still accepted via alias (ADR Phase 4).
 */
function runtimeEnv() {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env;
  }
  return typeof process !== 'undefined' ? process.env : {};
}

/** `VITE_FOO` preferred; `REACT_APP_FOO` accepted for older Railway env names. */
function resolveEnvValue(env, name) {
  if (name.startsWith('REACT_APP_')) {
    const viteKey = `VITE_${name.slice('REACT_APP_'.length)}`;
    const viteValue = env[viteKey];
    if (viteValue !== undefined && viteValue !== null) {
      return viteValue;
    }
  }
  const value = env[name];
  if (value !== undefined && value !== null) {
    return value;
  }
  return undefined;
}

export function readFeEnv(name, fallback = '') {
  const env = runtimeEnv();
  const value = resolveEnvValue(env, name);
  if (value === undefined || value === null) {
    return fallback;
  }
  return String(value);
}
